import React, { useEffect, useState } from "react";
import "../styles/LoginPage.css"; // Reuse login page styles
import defaultLogo from "../assets/images/bklogo.png";
import { FaAndroid, FaApple } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom"; // Use Link for navigation
import axios from "axios";
import {
  getRegisterAdmin,
  clearRegisterState,
} from "../redux/slices/getRegisterSlice"; // Import registration actions
import { setShowMessage } from "../redux/slices/notificationSlice";
import { isAdminExist } from "../redux/slices/adminSlice"; // Keep if needed post-registration check

function RegistrationPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const registerState = useSelector(
    (state) => state.getRegisterSlice.registerState
  );

  const [loading, setLoading] = useState(false); // Keep loading state

  const [registrationData, setRegistrationData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
  });
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setRegistrationData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (registerState.message.result === "success") {
      localStorage.setItem("isAdminRegister", true);
      dispatch(setShowMessage("Registered successfully"));
      dispatch(isAdminExist());
      dispatch(clearRegisterState());
      //   navigate("/login");
    }
  }, [registerState]);

  function handleSubmit(event) {
    event.preventDefault();

    const {
      firstName,
      lastName,
      username,
      phoneNumber,
      password,
      confirmPassword,
    } = registrationData;

    if (
      firstName.trim() &&
      lastName.trim() &&
      username.trim() &&
      phoneNumber.trim() &&
      password &&
      confirmPassword
    ) {
      if (password !== confirmPassword) {
        dispatch(setShowMessage("Passwords do not match"));
        return;
      }

      dispatch(
        getRegisterAdmin({
          firstName,
          lastName,
          email: username,
          phoneNumber,
          password,
        })
      );
    } else {
      dispatch(setShowMessage("Please fill all the fields"));
    }
  }

  return (
    // Reuse the overall structure and classes from LoginPage
    <div className="login-page">
      <div className="form-wrapper">
        <div className="form-card">
          {/* --- Registration Heading --- */}
          <h2>Create your account</h2>

          {/* --- Registration Form --- */}
          <form onSubmit={handleSubmit}>
            {/* --- First Name --- */}
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <div className="input-container">
                {/* User Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="icon input-icon"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                  />
                </svg>
                <input
                  type="username"
                  id="firstName"
                  name="firstName"
                  placeholder="Enter your first name"
                  value={registrationData.firstName}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            {/* --- Last Name --- */}
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <div className="input-container">
                {/* User Icon (same as first name) */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="icon input-icon"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                  />
                </svg>
                <input
                  type="username"
                  id="lastName"
                  name="lastName"
                  placeholder="Enter your last name"
                  value={registrationData.lastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            {/* --- Email --- */}
            <div className="form-group">
              <label htmlFor="username">Email address</label>
              <div className="input-container">
                {/* Email Icon (Reused) */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="icon input-icon"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25"
                  />
                </svg>
                <input
                  type="username" // Use type="username" for basic validation
                  id="username"
                  name="username"
                  placeholder="Enter your username"
                  value={registrationData.username}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            {/* --- Phone Number --- */}
            <div className="form-group">
              <label htmlFor="phoneNumber">Phone Number</label>
              <div className="input-container">
                {/* Phone Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="icon input-icon"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 6.75z"
                  />
                </svg>
                <input
                  type="username"
                  id="phoneNumber"
                  name="phoneNumber"
                  placeholder="Enter your phone number"
                  value={registrationData.phoneNumber}
                  onChange={handleInputChange}
                  pattern="[0-9]*" // Basic pattern for numbers, adjust if needed
                  inputMode="numeric"
                  required
                />
              </div>
            </div>

            {/* --- Password --- */}
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="input-container">
                {/* Lock Icon (Reused) */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="icon input-icon"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
                  />
                </svg>
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Enter your password"
                  value={registrationData.password}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            {/* --- Confirm Password --- */}
            <div className="form-group mb-2">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <div className="input-container">
                {/* Lock Icon (Reused) */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="icon input-icon"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
                  />
                </svg>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="Confirm your password"
                  value={registrationData.confirmPassword}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>
            {/* --- Submit Button --- */}
            {/* Reuse signin-button class or create a new one like register-button */}
            <button type="submit" className="signin-button" disabled={loading}>
              {/* User Plus Icon or similar */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="icon button-icon"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"
                />
              </svg>
              {loading ? "Registering..." : "Register"}
            </button>
          </form>
          {/* --- End App Download Section --- */}
        </div>{" "}
        {/* End of form-card */}
      </div>{" "}
      {/* End of form-wrapper */}
    </div> // End of login-page
  );
}

export default RegistrationPage;
